import {
  ChangeDetectionStrategy,
  Component,
  effect,
  inject,
  input,
  output,
} from '@angular/core';
import { type UUID } from '@bizzdesign/bizzdesign-sdk/uuid';
import { SharedI18nModule } from '@bizzdesign/shared/i18n';
import {
  DefaultDialogSize,
  type DialogProperties,
  type ObjectDto,
} from '@bizzdesign/shared/models';
import { DialogComponent } from '@bizzdesign/ui-components';
import { ButtonModule } from 'primeng/button';
import { ProgressSpinner } from 'primeng/progressspinner';
import { EditDataDialogComponentStore } from './edit-data-dialog.component.store';
import { StatusDialogComponent } from '@bizzdesign/ui-status-dialog';

@Component({
  selector: 'bd-edit-data-dialog',
  imports: [
    ButtonModule,
    DialogComponent,
    ProgressSpinner,
    SharedI18nModule,
    StatusDialogComponent,
  ],
  providers: [EditDataDialogComponentStore],
  templateUrl: './edit-data-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EditDataDialogComponent {
  readonly store = inject(EditDataDialogComponentStore);

  loading = input<boolean>(false);
  selectedObjects = input<ObjectDto[]>([]);
  showWarning = input<boolean>(false);

  cancelLoading = output<void>();
  confirm = output<UUID[]>();
  dismiss = output<void>();

  readonly loadingDialogProperties: DialogProperties = {
    defaultHeader: { headerTitle: '' },
    defaultSize: DefaultDialogSize.SMALL,
  };

  constructor() {
    effect(() => {
      this.store.updateSelectedObjects(this.selectedObjects());
    });
  }

  onCancelLoading(): void {
    this.cancelLoading.emit();
  }

  onConfirm(): void {
    this.confirm.emit(this.store.editableObjectIds());
  }

  onDismiss(): void {
    this.dismiss.emit();
  }
}
